module.exports = __webpack_public_path__ + "static/pho3-247000fe4a781b9210b33c433f1ccdb3.jpg";